export const styles = theme => ({
  root: {
    height: 380,
    transform: 'translateZ(0px)',
    flexGrow: 1,
  },
  speedDial: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  speedDialMoblie: {
    width: '100%',
    position: 'fixed',
    zIndex: 9999,
    bottom: 0,
    right: 2,
  },
  action: {
    background: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: '#021e33',
    }
  },
});